import { spaceTabsSlice } from './slice';
export const { embedStart, createStart, createSuccess, createFailure, saveSpaceTabs, addSpaceTab, updateSpaceTabTitle, setActiveTabKey, deleteStart, deleteSuccess, deleteFailure, updateStart, fetchDetailStart, saveNormalizedSpaceTabs, addTaskToSpaceTab, updateSpaceTabTaskList, removeTaskFromSpaceTab } = spaceTabsSlice.actions;
export const spaceTabsReducer = spaceTabsSlice.reducer;
export * from './schema';
